// extracted by mini-css-extract-plugin
module.exports = {"tab":"sidebar_tab__eP1Fn"};